export default __webpack_public_path__ + "static/media/171216ayatori_133.401a3254.jpg";